<div class="component-container" *ngIf="loaded">
    
    <div id="builder-container">
        
        <div id="back-wrap">
	        <a (click)="back()" class="back">
	            <svg class="back-arrow" width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
	                <path d="M 14 1 L 24 10 M 14 19 L 24 10 H 1" stroke="currentcolor"
	                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
	            </svg>
	            <span class="back-text">Back to Search &amp; Browse</span>
	        </a>
	    </div>
	    
        <div id="pages-container">
            
            <div class="page">
	           <span class="page-title">Cover Page</span>
	           <button (click)="editCover()">Edit</button>
            </div>
            
	        <div class="page" *ngFor="let config of quoteService.configs">
	            
	            <span class="page-title">{{ config.description }}</span>
	            <button class="edit-button" (click)="edit(config)">Edit</button>
	            <button class="delete-button" (click)="deleteConfiguration(config)">Delete</button>
	        
	        </div>
        </div>
        
        <div id="button-container">
            <button id="generate-button" (click)="generatePDF()">Generate Proposal PDF</button>
            <button id="export-button" (click)="exportXlsx()">Item List for Ordering</button>
        </div>
    
    </div>
    
    <!-- <div id="viewer-container">
    
        <iframe *ngIf="generated && !needEmail" src="api/generate/Quote"></iframe>
    
    </div> -->

</div>


<div id="cover-editor" [ngClass]="{ visible: editingCover }">
    
    <div id="cover-editor-bg"></div>
    <div id="cover-editor-form">
        <div class="button-wrap">
            <button id="close-cover-button" (click)="closeEditCover()">Close</button>
        </div>
        <div class="field-wrap">
            <label for="title">Title</label>
            <input id="title" type="text" 
            [(ngModel)]="coverSettings.title"
            (change)="editCoverField( 'title' )"
            maxlength="100" />
        </div>
        <div class="field-wrap">
            <label for="prepared-for">Customer Name</label>
            <input id="prepared-for" type="text" 
            [(ngModel)]="coverSettings.preparedFor"
            (change)="editCoverField( 'preparedFor' )"
            maxlength="100" />
        </div>
        <div class="field-wrap">
            <label for="prepared-by">Your Name</label>
            <input id="prepared-by" type="text" 
            [(ngModel)]="coverSettings.preparedBy"
            (change)="editCoverField( 'preparedBy' )"
            maxlength="100" />
        </div>
        <div class="field-wrap">
            <label for="phone-number">Phone Number</label>
            <input id="phone-number" type="text" 
            [(ngModel)]="coverSettings.phone"
            (change)="editCoverField( 'phone' )"
            maxlength="20" />
        </div>
        <div class="field-wrap">
            <label for="email">Email</label>
            <input id="email" type="text" 
            [(ngModel)]="coverSettings.email"
            (change)="editCoverField( 'email' )"
            maxlength="100" />
        </div>
        <div class="field-wrap">
            <label for="vertical">Vertical Market</label>
            <select id="vertical" 
            [(ngModel)]="coverSettings.vertical"
            (change)="editCoverField( 'vertical' )">
                <option></option>
                <option *ngFor="let v of allVerticals">{{ v }}</option>
            </select>
        </div>
    </div>
</div>

<div id="email-entry" class="visible" *ngIf="needEmail">
    <div id="email-entry-bg"></div>
    <div id="email-entry-form">
        <div>Please enter your email address to continue:</div>
        <input type="text" [(ngModel)]="userEmail" />
        <button (click)="submitEmail()">Submit</button>
    </div>
</div>